(() => {
  const nav = document.querySelector('.js-video-filter-nav');
  if (!nav) return;

  const inner = nav.querySelector('.js-video-filter-nav__inner');

  const allCards = document.querySelectorAll('[data-video-page-card]');
  const uniqueTags = new Map();

  allCards.forEach(card => {
    const raw = card.dataset.tags || '';
    if (!raw.trim()) return;
    raw.split(',').forEach(t => {
      const handle = t.trim();
      if (!handle) return;
      if (!uniqueTags.has(handle)) {
        const label = handle
          .replace(/-/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase());
        uniqueTags.set(handle, label);
      }
    });
  });

  uniqueTags.forEach((label, handle) => {
    const btn = document.createElement('button');
    btn.className = 'js-video-filter-btn video-filter-nav__btn';
    btn.dataset.filter = handle;
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', 'false');
    btn.textContent = label;
    inner.appendChild(btn);
  });

  const getActiveFilter = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('filter') || 'all';
  };

  const applyFilter = (filter) => {
    inner.querySelectorAll('.js-video-filter-btn').forEach(btn => {
      const isActive = btn.dataset.filter === filter;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    allCards.forEach(card => {
      if (filter === 'all') {
        card.hidden = false;
        return;
      }
      const tags = (card.dataset.tags || '')
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);
      card.hidden = !tags.includes(filter);
    });

    document.querySelectorAll('.js-video-page__grid').forEach(grid => {
      const hasVisible = [...grid.querySelectorAll('[data-video-page-card]')]
        .some(c => !c.hidden);
      const section = grid.closest('.shopify-section');
      if (section) section.style.display = hasVisible ? '' : 'none';
    });
  };

  const setFilter = (filter) => {
    const params = new URLSearchParams(window.location.search);
    if (filter === 'all') {
      params.delete('filter');
    } else {
      params.set('filter', filter);
    }
    const query = params.toString();
    const newUrl = window.location.pathname + (query ? '?' + query : '');
    history.pushState({ filter }, '', newUrl);
    applyFilter(filter);

    const firstVisibleGrid = [...document.querySelectorAll('.js-video-page__grid')]
      .find(grid => {
        const section = grid.closest('.shopify-section');
        return section && section.style.display !== 'none';
      });

    if (firstVisibleGrid) {
      const firstVisibleSection = firstVisibleGrid.closest('.shopify-section');
      const headerHeight = document.querySelector('header, .header, #shopify-section-header, [data-header]')?.offsetHeight || 0;
      const navHeight = nav.closest('.shopify-section')?.offsetHeight || 0;
      const offset = firstVisibleSection.getBoundingClientRect().top + window.scrollY - headerHeight - navHeight;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };

  inner.addEventListener('click', e => {
    const btn = e.target.closest('.js-video-filter-btn');
    if (!btn) return;
    setFilter(btn.dataset.filter);
  });

  window.addEventListener('popstate', () => {
    applyFilter(getActiveFilter());
  });

  applyFilter(getActiveFilter());

  if (nav.classList.contains('video-filter-nav--sticky')) {
    const parentSection = nav.closest('.shopify-section');
    const header = document.querySelector('header, .header, #shopify-section-header, [data-header]');

    if (header) {
      const headerSection = header.closest('.shopify-section') || header;
      headerSection.style.zIndex = '200';
    }

    const getHeaderHeight = () => {
      return header ? header.getBoundingClientRect().height : 0;
    };

    if (parentSection) {
      const applySticky = () => {
        const headerHeight = getHeaderHeight();
        parentSection.style.position = 'sticky';
        parentSection.style.top = `${headerHeight}px`;
        parentSection.style.zIndex = '100';
        parentSection.style.paddingTop = '0';
        parentSection.style.paddingBottom = '0';
        parentSection.style.marginTop = '0';
        parentSection.style.marginBottom = '0';
      };

      applySticky();

      if (window.ResizeObserver && header) {
        const ro = new ResizeObserver(applySticky);
        ro.observe(header);
      }
    }
  }
})();
